module.exports = __webpack_public_path__ + "img/马蜂窝_01.536b93ef.jpg";